import { render, staticRenderFns } from "./SeleccionFormatoInforme.vue?vue&type=template&id=04e9a7a3&scoped=true&"
import script from "./SeleccionFormatoInforme.vue?vue&type=script&lang=ts&"
export * from "./SeleccionFormatoInforme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e9a7a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('04e9a7a3', component.options)
    } else {
      api.reload('04e9a7a3', component.options)
    }
    module.hot.accept("./SeleccionFormatoInforme.vue?vue&type=template&id=04e9a7a3&scoped=true&", function () {
      api.rerender('04e9a7a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ProgramacionInforme/ComponentesInformes/SeleccionFormatoInforme.vue"
export default component.exports